export class ParticlesInteractorBase {
    constructor(container) {
        this.type = "particles";
        this.container = container;
    }
}
